import Vue from "vue";
import Router from "vue-router";
import store from "../store";
import Token from '../assets/js/token'

Vue.use(Router);

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

const vueRouter = new Router({
  routes: [
    {
      path: "/signin",
      name: "登录",
      component(resolve) {
        require(["../pages/signin/signin.vue"], resolve);
      },
      meta: {}
    },
    {
      path: "/home",
      name: "home",
      component(resolve) {
        require(["../components/home/home.vue"], resolve);
      },
      children: [
        {
          path: "/homepage",
          name: "测绘估算",
          component(resolve) {
            require(["../pages/homepage/homepage.vue"], resolve);
          },
          meta: {
            //判断是否头部各自展示的内容
            showContentHeader: 0,
            //导航栏判断字段
            indexNumber: 0
          }
        },
        {
          path: "/proposal",
          name: "建议书管理",
          component(resolve) {
            require(["../pages/proposal-management/index.vue"], resolve);
          },
          meta: {
            //判断是否展示头部图片
            showContentHeader: 2,
            //导航栏判断字段
            indexNumber: 1
          }
        },
        {
          path: "/proposaladd/:roofArea?/:installCap?",
          name: "新建项目", // 新建项目
          component(resolve) {
            require(["../pages/proposal-add/index.vue"], resolve);
          },
          meta: {
            //判断是否展示头部图片
            showContentHeader: 2,
            //导航栏判断字段
            indexNumber: 1
          }
        },
        {
          path: "/regionalresourceassessment",
          name: "地区资源评估",
          component(resolve) {
            require(["../pages/regional-resource-assessment/index.vue"], resolve);
          },
          meta: {
            //判断是否展示头部图片
            showContentHeader: 2,
            //导航栏判断字段
            indexNumber: 2
          }
        },
        {
          path: "/order",
          name: "订单管理",
          component(resolve) {
            require(["../pages/order-list/index.vue"], resolve);
          },
          meta: {
            //判断是否展示头部图片
            showContentHeader: 3,
            //导航栏判断字段
            indexNumber: 3
          }
        },
      ]
    }
  ],
  //刷新页面回到顶部
  scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    };
  }
});
vueRouter.beforeEach((to, from, next) => {
  // 判断中英文
  let chineseEnglish = localStorage.getItem("chineseEnglish") || 'zh_CN';
  store.commit("chineseEnglish", chineseEnglish);

  store.commit("changeValue", to.meta);
  let token = Token.get()

  // let login = '88888'
  let path = to.path;
  if (token) {
    // 无用户信息则调用接口获取
    const {userInfo} = store.state
    if (!(userInfo && userInfo.username)) {
      store.dispatch('getCurrentUser').then()
    }

    if (path === "/") {
      next({path: "/homepage"});
    } else {
      if (Object.keys(store.state.dictData || {}).length === 0) {
        store.dispatch('dict').then()
      }
      next();
    }
  } else {
    if (to.path === "/signin") {
      next();
    }

    // 增加判断条件
    if (to.path !== "/signin") {
      next("/signin");
    }
  }
});

export default vueRouter;



// WEBPACK FOOTER //
// ./src/router/index.js